/**
 * @file index.tsx
 *
 * @fileoverview Displays a facet box (to be used on the sidebar on a search page for example).
 */
import { ReactNode } from "react";
import ArrowDownIcon from "@jq-icons/ArrowDown";
import ButtonDiv from "../../../../02-atoms/01-forms/01-button/03-button-div";
import { Popover } from "../../../../02-atoms/16-popover";
import styles from "../facet.module.scss";

export interface FacetPopoverProps {
  /**
   * The contens to go into the box.
   */
  children: ReactNode;
  /**
   * The label to display in the trigger.
   *
   * @default "Open"
   */
  label?: ReactNode;
  /**
   * The facet popover toggle callback.
   */
  onToggle?: (shown: boolean) => void;
  /**
   * The opened flag for controling popover component.
   */
  opened?: boolean;
  /**
   * The outside click callback.
   */
  onOutsideClick?: () => void;
  /**
   * The trigger click callback.
   */
  onTriggerClick?: () => void;
  /**
   * The arrow down icon title.
   *
   * @default "Down"
   */
  arrowDownIconTitle?: string;
}

/**
 * A facet popover displays facet information inside a popover element.
 */
export const FacetPopover = ({
  children,
  label = "Open",
  arrowDownIconTitle = "Down",
  ...props
}: FacetPopoverProps) => {
  return (
    <Popover
      maxHeight="250px"
      trigger={
        <ButtonDiv buttonStyle="default" bordered>
          <span>{label}</span>
          <ArrowDownIcon title={arrowDownIconTitle} />
        </ButtonDiv>
      }
      padding={6}
      {...props}
    >
      <div className={styles.facet}>{children}</div>
    </Popover>
  );
};
